import { Table } from '@zillow/constellation-10';
import { type ProspectOpportunity } from './OverviewMap.hooks';

export const Top5LeadOpportunities = ({
  bottom5PropertiesByLead,
}: {
  bottom5PropertiesByLead: Array<ProspectOpportunity>;
}) => {
  return (
    <Table.Root aria-label="Top prospect opportunities" appearance="horizontal">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Property</Table.HeaderCell>
          <Table.HeaderCell css={{ textAlign: 'right' }}>Prospects, MTD</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {bottom5PropertiesByLead.map((property) => (
          <Table.Row key={property.propertyAlias}>
            <Table.Cell>{property.propertyName}</Table.Cell>
            <Table.Cell css={{ textAlign: 'right' }}>{property.prospectCount}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};
